<template>
  <div class="popup">
    	 <div class="participate" v-show="$store.state.show">
    	 	   <i class="off" @click="handleoffPop">
                 <img src='../assets/img/X1.png' />
               </i>
              <div class="partext"   >
              	     <h5 v-if='$store.state.type==1'>获取免费体验资格</h5>
                     <h5 v-if='$store.state.type==2'>立即加盟小语</h5>
                <!--   <div class="form">
                      <s>*</s>
                       <span>所属行业</span>
	                      
	                      <select class=" txt" v-model="form.Business">
                             <option>请选择</option>
	                         <option>互联网/IT</option>
	                         <option>金融/保险</option>
	                         <option>房地产/建筑</option>
	                         <option>商业服务</option>
	                         <option>贸易/批发/零售</option>
	                         <option>教育/艺术</option>
	                         <option>服务业</option>
	                         <option>文化/传媒/娱乐</option>
	                         <option>其他</option>
	                      </select>
                   </div>
                    <div class="form">
	                      <s>*</s>
	                   	  <span>区域</span>
	                      <select class="txt" id='province'  v-model="form.AreaName">
                                <option>请选择</option>
	                            <option v-for='item in provinceArr'>{{item}}</option>
	                      </select>
	                </div>-->
                   <div class="form">
                      <s>*</s>
                   	  <span>姓名</span>
                      <input type="text" placeholder="请填写您的姓名" class="name txt" v-model="form.name" maxlength="16"/>

                   </div>
                   <div class="form">
                      <s>*</s>
                   	  <span>电话</span>
                      <input type="text" placeholder="请填写您的电话" class="tel txt" v-model="form.tel" maxlength="12"/>
                      <a href="javascript:;" @click="yzm" v-if="$store.state.isyzm1==0">获取验证码</a>
                    <a href="javascript:;" v-else><span v-text="$store.state.isyzm1"></span>S</a>
                   </div>
                   <div class="form">
                        <s>*</s>
                        <span>验证码</span>
                        <input type="text" placeholder="请填写验证码" class="tel txt" v-model="form.VerificationCode" maxlength="4"/>
                   </div>
                  <!-- <div  class="form">
                      <s>*</s>
                        <span>产品</span>
                        <select id="Product" name="Product" class="form-control" v-model="form.Product">
                        <option value="">请选择您关注的产品</option>
                        <option value="智能客服系统iService（适用企业全渠道客服建设）">智能客服系统iService（适用企业全渠道客服建设）</option>
                        <option value="智能语音机器人iCall（适用电话营销、通知回访等）">智能语音机器人iCall（适用电话营销、通知回访等）</option>
                        <option value="智能语音通讯平台AiLink（呼叫中心、智能IVR建设）">智能语音通讯平台AiLink（呼叫中心、智能IVR建设）</option>
                        <option value="智能质检系统iCheck（智能语音识别，自动通话质检）">智能质检系统iCheck（智能语音识别，自动通话质检）</option>
                        <option value="智能AI助手iAssist（实时辅助坐席，提升业务技能）">智能AI助手iAssist（实时辅助坐席，提升业务技能）</option>
                    </select>
                   </div>-->
                   <div class="form">
                        <s></s>
                        <span>行业</span>
                        <select id="IndustryType" name="IndustryType" class="form-control" v-model="form.IndustryType">
                            <option value="">请选择行业</option>
                            <option value="保险">保险</option>
                            <option value="教育">教育</option>
                            <option value="金融">金融</option>
                            <option value="房地产">房地产</option>
                            <option value="医美/体检/健康保健">医美/体检/健康保健</option>
                            <option value="人力资源/教育培训/企业服务/招聘">人力资源/教育培训/企业服务/招聘</option>
                            <option value="4S店/运输/汽车">4S店/运输/汽车</option>
                            <option value="招商/展会/广告/营销">招商/展会/广告/营销</option>
                            <option value="客服外包/客户回访">客服外包/客户回访</option>
                            <option value="运营商/政务">运营商/政务</option>
                            <option value="会员营销/互联网/市场调研">会员营销/互联网/市场调研</option>
                            <option value="装修/家居/建材">装修/家居/建材</option>
                            <option value="餐饮">餐饮</option>
                        </select>
                    </div>
                  <!-- <div class="form">
                      <s></s>
                   	  <span>备注</span>
                      <input type="text" placeholder="请填写您的备注" class="tel txt" v-model="form.Business"/>
                   </div>-->
                   <p class="error" v-if="$store.state.error">{{$store.state.error}}</p>
                   <div class="form btnform">
                      <input type="button" value="提交" class="btn" @click="sub"/>
                   </div>
            </div>
      </div>  
     <div class='success' v-show="!$store.state.show">
          <i class="off" @click="handleoffPop">
             <img src='../assets/img/X1.png'/>
          </i> 
         <div class="message">
             <p>提交成功！</p>
         </div>     
    </div>
  </div>
</template>

<script>
export default {
  name: 'popup',
  data () {
    return {
        form:{
            Business:"",
            AreaName:'请选择',
            name:'',
            IndustryType:'',
            tel:"",
            source:1,
            VerificationCode:'',
            Product:''
        },
        provinceArr:['北京市','天津市','上海市','重庆市','河北省','河南省','云南省','辽宁省','黑龙江省','湖南省','安徽省','山东省','新疆维吾尔自治区',
           '江苏省','浙江省','江西省','湖北省','广西壮族','甘肃省','山西省','内蒙古自治区','陕西省','吉林省','福建省','贵州省','广东省','青海省',
          '西藏','四川省','宁夏回族','海南省','香港特别行政区','澳门特别行政区']
    }
  },
  methods:{
      handleoffPop(){
          this.$store.commit("offpop",false);
          this.form.Business='';
          this.form.AreaName='请选择';
          this.form.name="";
          this.form.tel='';
          this.form.IndustryType='';
          this.form.Product=''
          this.$store.state.error='';
      },
      sub(){
         // console.log(this.form)
          this.$store.commit("submintData",this.form);
      },
      yzm(){
          this.$store.commit("submintYZM",this.form);
      }
  },
  mounted() {
      
  },
}
</script>


<style scoped>
.popup{
   width:100%;
   height:100%;
   position:fixed;
   top:0;
   background:rgba(0,0,0,0.5);
   z-index:99999;
}
.participate{
    width:6.4rem;
    background:#fff;
    margin:0.8rem auto;
    border-radius:0.06rem;
    -moz-border-radius:0.06rem;
    -webkit-border-radius:4px;
    overflow:hidden;
}
 .off{
    width:0.36rem;
	height:0.36rem;
	display:block;
	float:right;
	margin:0.2rem; 
}
.off img{
    width:0.36rem;
	height:0.36rem;
	display:block;
}
.participate .partext{
    width:100%;
    float:right;
}
.participate .partext h5{
    font:0.36rem/0.4rem 'MicrosoftYaHei';
	color:#3296fa;
	text-align:center;
}
.participate .partext .form{
    width:5.3rem;
    margin:0 0.4rem;
    border:0.02rem solid #ccc;
	overflow:hidden;
	border-radius:0.04rem;
	-moz-border-radius:0.04rem;
	-webkit-border-radius:0.04rem;
    padding:0 0.15rem;
    margin-top:0.3rem;
    position: relative;
}
.participate .partext .form s{
    color:#ff0000;
    font:0.24rem/0.8rem 'MicrosoftYaHei';
    display:inline-block;
    width:0.1rem;
}
.participate .partext .form span{
   font:0.24rem/0.8rem 'MicrosoftYaHei';
   color:#333;
}
.participate .partext .form input{ 
    width:3rem;
    height:0.8rem;
    border:none;
    padding:0 0.1rem;
}
.participate .partext .form.btnform{
    border:none; 
    padding:0;
    width:5.61rem;
}
.participate .partext .form.btnform input{
    width:5.61rem;
    margin:0rem 0 0.5rem 0;
    background:#3296fa;
    color:#fff;
    font:0.3rem 'MicrosoftYaHei';
}
.error{
    padding:0 0.4rem;
    margin-top:0.3rem;
    color:#ff0000;
    font-size:0.24rem;
}
.success{
    width:4rem;
    height:2.5rem;
    background:#fff;
    margin:4.5rem auto;
    border-radius:0.06rem;
    -moz-border-radius:0.06rem;
    -webkit-border-radius:4px;
    overflow:hidden;
}
.message{
  width:100%;
  float:right;
}
.message p{
    text-align:center;
    font:0.4rem/1rem 'MicrosoftYaHei';
}
.txt{
    width: 3.8rem;
    height: 0.8rem;
    border: none;
    padding: 0 0.1rem;
    background:#fff;
}
select{
    border:none;
    height:0.8rem;
    background:#fff;
    width:4rem;
}
.form .yzm{
    position: absolute;
    top:0;
    right: 0;
    line-height: 0.8rem;
    font-size: 0.24rem;
    border-left: 1px solid #ccc;
    width: 1.56rem;
    text-align: center;
    display: block;
}

</style>



// WEBPACK FOOTER //
// src/components/popup.vue